<template>
  <v-col>
    <v-autocomplete
      :items="types"
      :rules="[required]"
      item-text="key"
      item-value="value"
      outlined
      label="Ersättningstyp"
      v-model="type"
    />
  </v-col>
</template>

<script>
import { sync } from 'vuex-pathify'
import replacementTypes from '@/common/replacementTypes'
import { required } from '@/common/validationRules'

export default {
  name: 'ReplacementTypeField',

  data: () => ({
    required,
    replacementTypes
  }),

  watch: {
    type(v) {
      if (v === 'SHUTTLE') {
        this.$store.set('replacement/model@train_number', null)
      }
    }
  },

  computed: {
    type: sync('replacement/model@type'),

    types() {
      return Object.entries(replacementTypes).map(([k, v]) => ({
        key: v,
        value: k
      }))
    }
  }
}
</script>
